import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {RouterModule} from '@angular/router';
import {AuditLogService} from '@services/audit-log.service';
import {ToastrService} from 'ngx-toastr';
import {PaginatorModule} from 'primeng/paginator';
import {TableModule} from 'primeng/table';
import {TooltipModule} from 'primeng/tooltip';
import {
    SearchFilterComponent,
    FilterConfig
} from '@components/search-filter/search-filter.component';

@Component({
    selector: 'app-audit-log',
    standalone: true,
    imports: [
        CommonModule,
        TableModule,
        PaginatorModule,
        TooltipModule,
        RouterModule,
        SearchFilterComponent
    ],
    templateUrl: './audit-log.component.html',
    styleUrl: './audit-log.component.scss'
})
export class AuditLogComponent implements OnInit {
    totalRecords: number = 0;
    pageSize: number = 10;
    currentPage: number = 1;
    public loading = true;
    public auditlogList: any[] = [];
    public filteringData: any = null;
    public isPaginator: boolean = true;
    filterConfig: FilterConfig;

    constructor(
        private auditlogService: AuditLogService,
        private toastr: ToastrService
    ) {}

    ngOnInit() {
        this.updateFilterConfig();
        this.getAuditLogList();
    }

    updateFilterConfig() {
        this.filterConfig = {
            fields: [
                {
                    key: 'EntityName',
                    label: 'Entity Name',
                    type: 'text',
                    placeholder: 'Entity Name'
                },
                {
                    key: 'EntityId',
                    label: 'Entity ID',
                    type: 'number',
                    placeholder: 'Entity ID'
                },
                {
                    key: 'ActionType',
                    label: 'Action Type',
                    type: 'text',
                    placeholder: 'Action Type'
                },
                {
                    key: 'Status',
                    label: 'Status',
                    type: 'text',
                    placeholder: 'Status'
                },
                {
                    key: 'FromDate',
                    label: 'From Date',
                    type: 'date',
                    placeholder: 'From Date'
                },
                {
                    key: 'ToDate',
                    label: 'To Date',
                    type: 'date',
                    placeholder: 'To Date'
                }
            ]
        };
    }

    onCustomFilter(filter: any) {
        this.filteringData = filter;
        this.currentPage = 1;
        this.getAuditLogList(this.filteringData);
    }

    onCustomFilterClear() {
        this.filteringData = null;
        this.currentPage = 1;
        this.getAuditLogList();
    }

    getAuditLogList(filters?: any) {
        this.loading = true;
        this.auditlogService
            .getAuditLogList(this.currentPage, this.pageSize, filters)
            .subscribe((response) => {
                if (response.totalRecords > 0) {
                    this.totalRecords = response.totalRecords;
                    this.auditlogList = response.auditLog;
                    this.loading = false;
                } else {
                    this.isPaginator = false;
                    this.auditlogList = response.auditLog;
                    this.toastr.warning('No Records Found');
                    this.loading = false;
                }
            });
    }

    onPageChange(event: any) {
        this.currentPage = event.page + 1;
        this.getAuditLogList(this.filteringData);
    }
}
